




export const INTERNAL_SDK_CONNECTION_STATE_CHANGED = "internal:sdk:connectionStateChanged";


export type InternalSdkName = "conversations" | "voice" | "taskrouter";


export type InternalSdkConnectionState = "connected" | "connecting" | "disconnected" | "notInitialized";
